/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { IRelatives } from 'app/shared/model/relatives.model';

export interface IFamilyHistory {
  id?: string;
  relationShip?: string | null;
  currAge?: string | null;
  ageOfDeath?: string | null;
  medicalProblems?: string | null;
  active?: boolean | null;
  draft?: boolean;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  patient?: IGlucoUser | null;
  relative?: IRelatives | null;
}

export const defaultValue: Readonly<IFamilyHistory> = {
  active: false,
  draft: false,
};
